// Markdown -> HTML for agent replies. Text is escaped first, so only the tags built here
// can appear in the output. Ported from the HCSG Aivio web client.
const escapeHtml = (s) => String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");

function inline(text) {
  return text
    .replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>")
    .replace(/__(.+?)__/g, "<strong>$1</strong>")
    .replace(/`([^`]+?)`/g, "<code>$1</code>")
    .replace(/(^|[\s(])\*(?!\s)([^*\n]+?)\*(?=[\s).,:;!?]|$)/g, "$1<em>$2</em>")
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
    .replace(/\s+(?=\[\d+\])/g, " ")
    .replace(/\[(\d+)\]/g, '<button type="button" class="ac-cite" data-cite="$1" aria-label="Source $1">$1</button>');
}

// While streaming, hide a table row that hasn't finished arriving and a '**' whose
// closing pair hasn't arrived yet.
export function tidyPartial(text) {
  const lastBreak = text.lastIndexOf("\n");
  const lastLine = text.slice(lastBreak + 1);
  if (/^\s*\|/.test(lastLine)) text = text.slice(0, lastBreak + 1);
  const parts = text.split("**");
  if (parts.length % 2 === 1) return text;
  const at = text.lastIndexOf("**");
  return text.slice(0, at) + text.slice(at + 2);
}

export function formatReply(raw) {
  const lines = escapeHtml(raw).split(/\r?\n/);
  let html = "";
  let list = null;
  let i = 0;
  const closeList = () => {
    if (list) {
      html += `</${list}>`;
      list = null;
    }
  };

  while (i < lines.length) {
    const line = lines[i];

    if (/^\s*\|.*\|\s*$/.test(line)) {
      closeList();
      const rows = [];
      while (i < lines.length && /^\s*\|.*\|\s*$/.test(lines[i])) rows.push(lines[i++]);
      const cells = (row) => row.trim().replace(/^\||\|$/g, "").split("|").map((c) => c.trim());
      const isSeparator = (row) => /^\s*\|?[\s:|-]+\|?\s*$/.test(row) && row.includes("-");
      let table = '<div class="ac-tbl"><table>';
      rows.forEach((row, index) => {
        if (isSeparator(row)) return;
        const tag = index === 0 && rows[1] && isSeparator(rows[1]) ? "th" : "td";
        table += `<tr>${cells(row).map((c) => `<${tag}>${inline(c)}</${tag}>`).join("")}</tr>`;
      });
      html += `${table}</table></div>`;
      continue;
    }

    let m;
    if ((m = line.match(/^\s*[-*•]\s+(.*)/))) {
      if (list !== "ul") { closeList(); html += "<ul>"; list = "ul"; }
      html += `<li>${inline(m[1])}</li>`;
    } else if ((m = line.match(/^\s*\d+[.)]\s+(.*)/))) {
      if (list !== "ol") { closeList(); html += "<ol>"; list = "ol"; }
      html += `<li>${inline(m[1])}</li>`;
    } else if ((m = line.match(/^\s*#{1,6}\s+(.*)/))) {
      closeList();
      html += `<h4>${inline(m[1])}</h4>`;
    } else if (/^\s*([-*_])\1{2,}\s*$/.test(line)) {
      closeList();
      html += "<hr>";
    } else if (line.trim() === "") {
      closeList();
    } else {
      closeList();
      html += `<p>${inline(line)}</p>`;
    }
    i += 1;
  }
  closeList();
  return html || "<p></p>";
}
